/// <reference path="./notificationSetting.base.section.ts" />

module Meevo.Plugins.NotificationSetting {
    "use strict";
    import CommunicationTypeEnum = Meevo.Model.CommunicationTypeEnum;
    import PhoneVerificationStatusEnum = Meevo.Model.PhoneVerificationStatusEnum;
    import PhoneVerificationWorkFlowEnum = Meevo.Model.PhoneVerificationWorkFlowEnum;
    /**
    * Main Section of NotificationSetting
    */
    export class MainSection extends NotificationSettingBaseSection {

        public emailFromAddressLocalPart: any;
        public emailFromAddressRegex: RegExp = new RegExp('^[a-zA-Z0-9_.+-]+$', 'i');
        public hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

        public phoneNumberVerificationHistory: any;
      
        constructor( 
            protected isApplicationModeCO: boolean,
            protected isSingleLocation: boolean,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            public $translate: angular.translate.ITranslateService,
            public modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(isApplicationModeCO, isSingleLocation, sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);
        }

        activate(): void {
            super.activate();
            this.getPhoneNumberVerificationHistory();
        }

        extractEmailLocalPart(emailAddress): any {
            if (emailAddress !== "" && emailAddress !== undefined) {
                return emailAddress.substring(0, emailAddress.indexOf("@"));
            }
            return null;
        }

        takeBackup(): void {
            super.takeBackup();
            if (this.model) {
                this.emailFromAddressLocalPart = this.extractEmailLocalPart(this.model.emailFromAddress);
            }
        }

        rollbackChanges(): void {
            super.rollbackChanges();
            if (this.model) {
                this.emailFromAddressLocalPart = this.extractEmailLocalPart(this.model.emailFromAddress);
            }
        }

        preSave(): void{
            if (this.model && this.emailFromAddressLocalPart != "" && this.emailFromAddressLocalPart != undefined) {
                this.model.emailFromAddress = this.emailFromAddressLocalPart.concat("@meevomail.com");
            }
            else {
                this.model.emailFromAddress = null;
            }
        }

        isSettingEnabled(fieldName: string, settingModel: Meevo.Model.SettingsDto): boolean {
            let setting = _.find(settingModel.settings, setting => setting.displayName.toUpperCase() === fieldName.toUpperCase());
            if (Model.Guard.isNothing(setting)) return;

            if (setting.effectiveValue === "0")
                return false;

            return true;
        }

        getPhoneVerificationStatusDescription(status): string {
            if (status == PhoneVerificationStatusEnum.Rejected)
                return "LABEL_REJECTED";
            else if (status == PhoneVerificationStatusEnum.Submitted)
                return "LABEL_SUBMITTED";
            else if (status == PhoneVerificationStatusEnum.PendingVerification)
                return "LABEL_PENDING_VERIFICATION";
            else if (status == PhoneVerificationStatusEnum.Verified)
                return "LABEL_VERIFIED";
            else
                return "LABEL_NOT_SUBMITTED";
        }

        openPhoneNumberVerificationDetails(event, businessSettings?: Meevo.Model.SettingsDto): void {
            event.stopPropagation();
            var modalOptions: Meevo.Model.NotificationSetting = this.model;

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/notificationSetting/modals/phoneNumberVerification.template.html",
                controller: "meevo.plugins.notificationSetting.PhoneNumberVerificationController",
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: true,
                locals: {
                    options: modalOptions,
                    requirePrivacyPolicyUrls: businessSettings ? this.isSettingEnabled('requirePrivacyPolicyAndTermsAndConditions', businessSettings) : false
                }
            }
            this.modalService.showCustom(options);
        }

        needPhoneVerification(): boolean {
            return this.requirePhoneVerification()
                && (this.model.phoneVerificationStatus == null
                    || this.model.phoneVerificationStatus == PhoneVerificationStatusEnum.Submitted
                    || this.model.phoneVerificationStatus == PhoneVerificationStatusEnum.PendingVerification
                    || this.model.phoneVerificationStatus == PhoneVerificationStatusEnum.NotSubmitted
                    || this.model.phoneVerificationStatus == PhoneVerificationStatusEnum.Rejected);
        }

        requirePhoneVerification(): boolean {
            return this.model.phoneVerificationWorkflow == PhoneVerificationWorkFlowEnum.NorthAmerica
                && this.model.phoneNumberId
                && !Guid.empty.equals(this.model.phoneNumberId);
        }

        openPhoneNumberVerificationLog = (event) => {
            event.stopPropagation();
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/auditHistory/auditHistory.html",
                locals: {
                    auditLog: this.phoneNumberVerificationHistory,
                    userId: this.identityService.current().userId,
                    userName: this.identityService.current().userAuthName
                },
                controller: "meevo.auditHistory.AuditHistoryController",
                controllerAs: "auditHistory",
                bindToController: true
            }
            this.modalService.showCustom(options);
        }

        getPhoneNumberVerificationHistory = () => {
            if (this.model.phoneNumberId) {
                let request = {
                    asLocationId: this.identityService.locationId,
                    itemsPerPage: 30,
                    pageNumber: 0,
                    criteria: {
                        entityId: this.model.phoneNumberId,
                        startDate: moment().subtract(2, "years").toDate(),
                        endDate: moment().toDate(),
                        purpose: Meevo.Model.PurposeEnum.Audit,
                        nounId: Meevo.Model.NounEnum.PhoneNumber,
                    }
                }

                return this.dataService.customMethodData("api/ActivityLog/DataChange/List/", "post", request).then((res) => {
                    this.phoneNumberVerificationHistory = res.data;
                });
            }
        }
    }
}
